import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import Loader from '../../../loader/Loader'
import Text from '../../../input_filed/Text'
import SelectStatus from '../../../input_filed/SelectStatus'
import SaveButton from '../../../buttons/SaveButton'
import { ToastContainer, toast } from 'react-toastify'
import { useFormik } from 'formik'
import { CategorySchema } from './Validation'
import { AddCategoryRes, AddCategoryTodo } from '../../../../redux/slices/master_slice/vehical_category/AddCategory'
import { useDispatch } from 'react-redux'
import File from '../../../input_filed/File'

export default function AddCategoryForm(props) {
    const { bool, setBool } = props
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const initialValues = {
        category: '',
        image:'',
        status: ""
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: CategorySchema,

        onSubmit: (values, action) => {
            setLoading(true)
            dispatch(AddCategoryTodo(bodyFormData)).then(() => add_res(action))
        }
    })

    let bodyFormData = new FormData();
    bodyFormData.append("user_id", localStorage.getItem('user_id'))
    bodyFormData.append("vehicle_category_name", values.category)
    bodyFormData.append("vehicle_category_image", values.image)
    bodyFormData.append("vehicle_category_status", values.status)

    const add_res = (action) => {
        if (AddCategoryRes?.success) {
            setBool(!bool)
            setLoading(false)
            action.resetForm()
            toast.success(AddCategoryRes?.message, { position: "bottom-right" });
        } else {
            toast.error(AddCategoryRes?.message, { position: "bottom-right" });
            setLoading(false)
        }
    }
    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                <div className='form_layout mt-3'>
                    {loading ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :
                        <div className='row'>
                            <div className='col-md-4'>
                                <Text
                                    label_name='Category'
                                    placeholder=''
                                    required={true}
                                    name='category'
                                    value={values.category || ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.category && touched.category ? (<span className='text-danger form_label' >{errors.category}</span>) : null}
                                />
                            </div>
                            <div className='col-md-4  mb-2 '>
                                <File
                                    name='image'
                                    required={true}
                                    label_name={'Category Image '}
                                    onBlur={handleBlur}
                                    onChange={(e) => setFieldValue("image", e.currentTarget.files[0])}
                                    error={errors.image && touched.image ? (<span className='text-danger form_label' >{errors.image}</span>) : null}
                                />

                            </div>
                            <div className='col-md-4'>
                                <SelectStatus
                                    closeMenu={true}
                                    required={true}
                                    label_name='Status'
                                    disabled={false}
                                    name='status'
                                    defaultValue={''}
                                    onChange={(e) =>
                                        setFieldValue('status', e.value)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null}
                                />
                            </div>
                            <div className='col-md-12 text-end mt-2'>
                                <SaveButton name={'Save'} />
                            </div>
                        </div>}
                </div>
            </Form>
        </>
    )
}
